export const ADD_NOTE = 'notes.ADD_NOTE';
export const EDIT_NOTE_ACTIVE = 'notes.EDIT_NOTE_ACTIVE';
export const EDIT_NOTE_INACTIVE = 'notes.EDIT_NOTE_INACTIVE';
export const UPDATE_NOTE = 'notes.UPDATE_NOTE';
export const DELETE_NOTE = 'notes.DELETE_NOTE';